import React from 'react';

export default function ValuationRequests() {
  const sampleRequests = [
    { id: 'REQ-001', subject: 'Property A', status: 'pending' },
    { id: 'REQ-002', subject: 'Vehicle B', status: 'in-progress' },
  ];

  return (
    <main style={{ padding: 24 }}>
      <h1>Valuation Requests</h1>
      <p>List and manage incoming valuation requests.</p>

      <section style={{ marginTop: 24 }}>
        <ul>
          {sampleRequests.map((r) => (
            <li key={r.id} style={{ marginBottom: 8 }}>
              <strong>{r.id}</strong> — {r.subject} <em>({r.status})</em>
            </li>
          ))}
        </ul>
      </section>
    </main>
  );
}
